/**
 * API client per admin system status and actions.
 */

import api from './auth'

export interface SystemStatus {
  emails: Record<string, number>;
  emails_stuck_count: number;
  cases: Record<string, number>;
  cases_no_specialty: number;
  cases_no_vet: number;
  cases_routing_conflicts: number;
  celery_pending_tasks: number;
}

export interface ActionResponse {
  message: string;
  count: number;
}

export const adminApi = {
  /**
   * Ottiene lo stato del sistema.
   */
  getSystemStatus: async (): Promise<SystemStatus> => {
    const response = await api.get<SystemStatus>('/admin/system-status');
    return response.data;
  },

  /**
   * Trigger re-processing per email pending.
   */
  reprocessPending: async (): Promise<ActionResponse> => {
    const response = await api.post<ActionResponse>('/admin/actions/reprocess-pending');
    return response.data;
  },

  /**
   * Re-run routing per cases senza vet.
   */
  rerouteCases: async (): Promise<ActionResponse> => {
    const response = await api.post<ActionResponse>('/admin/actions/reroute-no-vet');
    return response.data;
  },

  /**
   * Fix email rimaste con status=NEW ma già processate.
   */
  fixStuckEmails: async (): Promise<ActionResponse> => {
    const response = await api.post<ActionResponse>('/admin/actions/fix-stuck-new');
    return response.data;
  },
};